import { render, staticRenderFns } from "./ModuleSetting.vue?vue&type=template&id=a992208c&"
import script from "./ModuleSetting.vue?vue&type=script&lang=js&"
export * from "./ModuleSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports